import { faFacebookF, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const icons = {
  facebook: faFacebookF,
  twitter: faTwitter,
  youtube: faYoutube,
};

const StyledLink = styled.a`
  font-size: 30px;
  color: ${(props) => props.theme.colors.white};
  background-color: rgba(255, 255, 255, 0.1);
  padding: 12px 14px 10px;
  border-radius: 40px;

  &:hover {
    color: ${(props) => props.theme.colors.light};
  }
`;

const SocialIcon = ({ href, icon }) => (
  <StyledLink href={href} className="ml-3">
    <FontAwesomeIcon icon={icons[icon]} fixedWidth />
  </StyledLink>
);

SocialIcon.propTypes = {
  href: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
};

export default SocialIcon;
